import React from 'react'
import { View } from 'react-native'
import { StyleService, useStyleSheet } from '@style/service'
import { Text } from '@components/base'
import { NoraHomeWalkthroughLayout } from './types'

export const NoraHomeActionStack = ({
  actions,
  layout,
}: {
  actions: string[]
  layout: NoraHomeWalkthroughLayout
}) => {
  const styles = useStyleSheet(themedStyles)
  const actionChipColors = [
    styles.actionChipFirst,
    styles.actionChipSecond,
    styles.actionChipThird,
    styles.actionChipFourth,
  ]

  return (
    <View
      style={[
        styles.actionStack,
        {
          gap: layout.actionStackGap,
        },
      ]}
    >
      {actions.map((action, index) => (
        <View
          key={action}
          style={[
            styles.actionChip,
            { minHeight: layout.actionChipHeight },
            actionChipColors[index % actionChipColors.length],
            index % 2 === 1 && styles.actionChipRight,
          ]}
        >
          <View style={styles.actionNumber}>
            <Text type="small" bold style={styles.actionNumberText}>
              {index + 1}
            </Text>
          </View>
          <Text type="regular" bold numberOfLines={1} style={styles.actionText}>
            {action}
          </Text>
        </View>
      ))}
    </View>
  )
}

const themedStyles = StyleService.create({
  actionStack: {
    width: '100%',
    paddingHorizontal: 16,
    marginBottom: 14,
  },
  actionChip: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    width: '80.5%',
    padding: 10,
    gap: 8,
    borderRadius: 16,
  },
  actionChipFirst: {
    backgroundColor: 'theme.surface.base',
  },
  actionChipSecond: {
    backgroundColor: 'theme.secondary.dark',
  },
  actionChipThird: {
    backgroundColor: 'theme.surface.base1',
  },
  actionChipFourth: {
    backgroundColor: 'theme.surface.banner',
  },
  actionChipRight: {
    alignSelf: 'flex-end',
  },
  actionNumber: {
    width: 24,
    height: 24,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'theme.primary.base',
  },
  actionNumberText: {
    color: 'theme.solid.white',
  },
  actionText: {
    flex: 1,
    color: 'theme.text.primary',
  },
})
